import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  browserSupportsWebAuthn,
  platformAuthenticatorIsAvailable,
  loginWithPasskey,
} from '../lib/webauthn';
import { useAuth } from '../contexts/AuthContext';
import Footer from '../components/Footer';

export default function LoginPage() {
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const [supported, setSupported] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!browserSupportsWebAuthn()) {
      setSupported(false);
      return;
    }
    platformAuthenticatorIsAvailable().then(setSupported);
  }, []);

  async function handleLogin() {
    setError(null);
    setLoading(true);
    try {
      const { token, user } = await loginWithPasskey();
      setSession(token, user);
      navigate('/');
    } catch (err: any) {
      setError(err.response?.data?.message || err.message || 'Erro ao autenticar');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 flex items-center justify-center px-4">
      <div className="card w-full max-w-sm space-y-4 text-center">
        <img src="/maestro-logo.png" alt="Maestro" className="h-24 w-auto mx-auto" />
        <h1 className="text-2xl font-bold text-brand-600 -mt-1">Maestro</h1>
        <p className="text-sm text-slate-600">Entre usando sua biometria.</p>

        {supported === false && (
          <div className="bg-red-50 text-red-700 text-sm rounded p-3">
            Este navegador ou dispositivo não suporta biometria. Use um navegador moderno
            (Safari/Chrome) num dispositivo com Touch ID/Face ID.
          </div>
        )}

        {error && (
          <div className="bg-red-50 text-red-700 text-sm rounded p-3 break-words">{error}</div>
        )}

        <button
          className="btn btn-primary w-full"
          onClick={handleLogin}
          disabled={loading || supported === false}
        >
          {loading ? 'Autenticando…' : 'Entrar com biometria'}
        </button>

        <a href="/registrar" className="block text-xs text-slate-500 underline">
          Primeiro acesso? Registrar dispositivo
        </a>
      </div>
      </div>
      <Footer />
    </div>
  );
}
